<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem to="/exhibition/index/case/all">案例</BreadcrumbItem>
          <BreadcrumbItem>编辑案例</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
    </div>
    <div class="my-item">
      <div class="addcase">
        <div class="f-tar" style="padding: 20px;">
          <Button @click="$router.push('/exhibition/index/case/all')">返回</Button>
        </div>
        <div class="addcase-box">
          <div class="my-modal">
            <div class="my-modal-content">
              <Form ref="formInline" :label-width="100" :model="formInline" :rules="ruleInline">
                <FormItem label="Logo：" :required="true">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList"
                    :key="'upload' + index"
                    style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width:100%;height:100%;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width:100px;"
                    v-show="uploadList && uploadList.length < 1"
                  >
                    <div
                      style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);"
                    >
                      <div style="font-size:25px;">
                        +
                        <p style="font-size:14px;">上传图片</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
                      @click.stop="selectType"
                    ></div>
                  </Upload>
                  <p style="font-size:12px;">(图片要求：2M以下的jpg或png，建议尺寸120*120px)</p>
                </FormItem>
                <FormItem label="案例名称：" prop="name">
                  <Input v-model="formInline.name" placeholder="请输入案例名称" />
                </FormItem>
                <FormItem label="背景图：" :required="true">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList2"
                    :key="'upload2' + index"
                    style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width:100%;height:100%;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr2(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload2"
                    :show-upload-list="false"
                    :default-file-list="defaultList2"
                    :on-success="handleSuccess2"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload2"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width:100px;"
                    v-show="uploadList2 && uploadList2.length < 1"
                  >
                    <div
                      style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);"
                    >
                      <div style="font-size:25px;">
                        +
                        <p style="font-size:14px;">上传</p>
                      </div>
                    </div>
                    <div
                      style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
                      @click.stop="selectType2"
                    ></div>
                  </Upload>
                  <p style="font-size: 12px;">(图片要求：2M以下jpg或png的图片，建议尺寸750*500px)</p>
                </FormItem>
                <FormItem label="概要：" prop="summary" :required="true">
                  <Input
                    type="textarea"
                    :rows="3"
                    :maxlength="100"
                    v-model="formInline.summary"
                    placeholder="请输入概要"
                  />
                  <div style="color:#bfbfbf;text-align: right;line-height: 20px;">{{ formInline.summary.length }} / 100 字</div> 
                </FormItem>
                <FormItem label=" " >
                  <Tag
                    v-show="tag && tag.length"
                    class="case-tag"
                    v-for="item in tag"
                    :key="item.index"
                    :name="item"
                    closable
                    @on-close="reduceTag"
                  >{{ item }}</Tag>
                  <span style="padding: 5px;display: inline-block;"></span>
                  <Poptip title="请输入标签内容" v-model="tagFlag">
                    <Button icon="ios-add" type="dashed" size="small" v-if="tag.length < 2">标签</Button>
                    <div slot="content">
                      <Input v-model="tagcount" />
                      <div style="display:flex;flex-direction:row-reverse;margin:5px;">
                        <Button @click="addTag()" type="primary" style="margin-left:10px;">添加</Button>
                        <Button @click="cancelTagActive()">取消</Button>
                      </div>
                    </div>
                  </Poptip>
                </FormItem>
                <FormItem>
                  <Checkbox size="large" v-model="formInline.isShow">
                    <span style="display: inline-block;width: 10px;"></span>Display
                  </Checkbox>
                </FormItem>
                <FormItem label="显示顺序：">
                  <InputNumber :min="0" v-model="formInline.showIndex"></InputNumber>
                </FormItem>
                <FormItem label="介绍：" :required="true">
                  <div class="no-padding">
                    <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal"></customComponentCommon>
                  </div>
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    :loading="loading"
                    @click="handleSubmit('formInline')"
                    style="width:140px;height:35px;font-size:14px;"
                  >保存</Button>
                  <Button
                    type="primary"
                    @click="$router.push('/exhibition/index/template')"
                    style="width:140px;height:35px;font-size:14px;margin-left:20px;"
                  >预览</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <iModal title="图片查看" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
    <imgUpload
      @upload:local="uploadLocal2"
      @upload:material="uploadMaterial2"
      :maxCount="1"
      v-model="uploadChooseShowed2"
    />
    <!-- <uploadChoose
      @upload:local="uploadLocal2"
      @upload:material="uploadMaterial2"
      fileType="img"
      :maxCount="1"
      v-model="uploadChooseShowed2"
    />-->
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions, mapGetters } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import uploadChoose from "@components/uploadChoose/uploadChoose";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";
export default {
  name: "add-case",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commonType: 2,
      Introduction: [],
      editData: null,

      imgName: "",
      loading: false,
      showModal: false,
      tag: [], // 案例标签
      tagcount: "",
      tagFlag: false,
      formInline: {
        name: "", // 名称
        summary: "", // 概要
        isShow: true, // 是否显示
        showIndex: 0 // 显示顺序
      },
      ruleInline: {
        // 效验规则
        name: [{ required: true, message: "必填选项", trigger: "blur" }],
        summary: [{ required: true, message: "必填选项", trigger: "blur" }]
      },
      uploadList: [], // Logo
      defaultList: [],
      uploadList2: [], // 背景图
      defaultList2: [],
      visible: false,
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      uploadChooseShowed2: false // 控制文件上传方式的显示和隐藏
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$router.history.current.query;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getExampleById: "companyModule/getExampleById",
      editExample: "companyModule/editExample",

      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData"
    }),
    async init() {
      if (!this.query.id) return;
      this.editData = await this.getExampleById(this.query.id);
      this.setData();
    },
    async setData() {
      console.log(111, this.editData);
      if (this.editData.name) {
        this.formInline.name = this.editData.name;
      }
      if (this.editData.summary) {
        this.formInline.summary = this.editData.summary;
      }
      this.formInline.isShow = this.editData.isShow;
      this.formInline.showIndex = this.editData.showIndex;
      if (this.editData.tag) {
        this.tag = JSON.parse(this.editData.tag);
      }
      if (
        this.editData.introduction &&
        this.editData.introduction.indexOf("[") !== -1
      ) {
        this.Introduction = await this.transformCustomData(
          JSON.parse(this.editData.introduction)
        );
      }
      if (this.editData.logo) {
        this.defaultList = [
          {
            name: this.editData.name,
            url: this.editData.logo,
            status: "finished",
            percentage: 100
          }
        ];
      }
      if (this.editData.cover) {
        this.defaultList2 = [
          {
            name: this.editData.name,
            url: this.editData.cover,
            status: "finished",
            percentage: 100
          }
        ];
      }
      this.uploadList = this.defaultList;
      this.uploadList2 = this.defaultList2;
    },
    cancelTagActive() {
      this.tagFlag = false;
    },
    addTag() {
      if (this.tag && this.tag.length >= 2) {
        this.$Message.warning("标签最多只可添加两个");
        return;
      }
      if (this.tagcount !== "") {
        this.tag.push(this.tagcount);
        this.tagcount = "";
      } else {
        this.$Message.warning("请输入标签内容");
      }
      this.tagFlag = false;
    },
    reduceTag(event, name) {
      const index = this.tag.indexOf(name);
      this.tag.splice(index, 1);
    },
    // 上传
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${limitNum} image only`);
      }
      return check;
    },
    handleBeforeUpload2() {
      const limitNum = 10;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${limitNum} image only`);
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let imgList = this.transfromImgList(this.uploadList);
      let imgList2 = this.transfromImgList(this.uploadList2);
      let time = this.formInline.time
        ? moment(this.formInline.time).format("YYYY-MM-DD")
        : "";
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传Logo`);
        return;
      }
      if (!(this.uploadList2 && this.uploadList2.length)) {
        this.$Message.error(`请上传背景图`);
        return;
      }
      // 介绍方式
      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error(`Please complete the details`);
        return;
      }
      let formData = {
        Id: this.query.id,
        SetValues: {
          Name: this.formInline.name,
          Logo: imgList[0],
          Cover: imgList2[0],
          Tag: this.tag,
          Summary: this.formInline.summary,
          IsShow: this.formInline.isShow,
          ShowIndex: this.formInline.showIndex,
          Introduction: Introduction
        }
      };
      console.log("formData", formData);
      this.loading = true;
      let bool = await this.editExample(formData);
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("修改成功");
        this.$router.push("/exhibition/index/case/all");
        // this.$emit("finish");
        this.close();
        this.$refs.upload.clearFiles();
        if (this.$refs.upload2) {
          this.$refs.upload2.clearFiles();
        }
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    // transfromImgList2(arr) {
    //   let arr2 = [];
    //   arr.forEach(c => {
    //     arr2.push({ url: c, name: "", status: "finished", percentage: 100 });
    //   });
    //   return arr2;
    // },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.loading = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      this.uploadList = [];
      this.defaultList = [];
      this.uploadList2 = [];
      this.defaultList2 = [];
      // this.formInline.activityType = "0";
      this.$emit("close");
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    selectType2() {
      this.uploadChooseShowed2 = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    uploadLocal2() {
      this.$refs.upload2.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    uploadMaterial2(e) {
      for (let item of e) {
        if (this.uploadList2.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList2.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed2 = false;
        }
      }
    }, 
    changModal($event) {
      this.Introduction = $event;
      console.log($event);
    }
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
    if (this.$refs.upload2) {
      this.uploadList2 = this.$refs.upload2.fileList;
    }
  },
  components: {
    imgUpload,
    uploadChoose,
    customComponentCommon
  }
};
</script>

<style lang="scss">
.case-tag {
  &:hover {
    border-color: #178fff;
    span {
      color: #178fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.addcase {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 800px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>